import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'
import { Controller } from 'core-components/library/validation'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'

import styles from './QBRFinalizeModalContent.module.scss'

interface IQBRErrorModalContentProps {
  onCloseButtonClick: () => void
  onFinalizeWithoutSavingClick: () => void
  onFinalizeWithSavingClick: () => void
}

export const QBRFinalizeModalContent = ({
  onCloseButtonClick,
  onFinalizeWithSavingClick,
  onFinalizeWithoutSavingClick,
}: IQBRErrorModalContentProps) => {
  return (
    <Controller>
      <div className={styles.root}>
        <div className={styles.title}>
          <Translation text={TRANSLATION_KEYS.finalizeModal.title} />
        </div>
        <div className={styles.mainText}>
          <Translation text={TRANSLATION_KEYS.finalizeModal.text} />
        </div>
        <div className={styles.btnWrapper}>
          <Button onClick={onFinalizeWithSavingClick} margin={'md'}>
            <Translation text={TRANSLATION_KEYS.finalizeModal.finalizeWithSaving} />
          </Button>
          <Button onClick={onFinalizeWithoutSavingClick} margin={'md'}>
            <Translation text={TRANSLATION_KEYS.finalizeModal.finalizeWithoutSaving} />
          </Button>
          <Button onClick={onCloseButtonClick} margin={'md'} color={'danger'}>
            <Translation text={TRANSLATION_KEYS.finalizeModal.cancel} />
          </Button>
        </div>
      </div>
    </Controller>
  )
}
